<template>
  <p v-if="information !== null && hasInputMappingInformation">
    {{ information.modell }}
    <br />
    {{ information.leistung }}KW/{{ psProxy }}PS,
    {{ information.antriebsart }}
    (
    <span :title="getSourceDisplayInformation(props.hsnPath)">
      HSN: {{ hsnInputMappingProxy }}
    </span>
    /
    <span :title="getSourceDisplayInformation(props.hsnPath)">
      TSN: {{ tsnInputMappingProxy }}
    </span>
    )
  </p>
</template>

<script lang="ts" setup>
import { useHsnTsn } from '@/features/HsnTsn/useHsnTsn';
import { computed, onMounted, ref } from 'vue';
import { kwToHp } from '@/utils/conversion/conversion';
import { useInputMappingStore } from '@/features/InputMapping/store';
import { CarInformation } from '@/features/HsnTsn/types';

interface Props {
  hsnPath: string;
  tsnPath: string;
}

const props = defineProps<Props>();

const hsnTsn = useHsnTsn();
const { getSourceDisplayInformation, getValue } = useInputMappingStore();

const hsnInputMappingProxy = computed(() => getValue(props.hsnPath));
const tsnInputMappingProxy = computed(() => getValue(props.tsnPath));

const information = ref<CarInformation | null>(null);

onMounted(async () => {
  information.value = await hsnTsn.revalidateHsnTsnInformation(
    hsnInputMappingProxy.value,
    tsnInputMappingProxy.value,
    true,
  );
});

const hasInputMappingInformation = computed(
  () => hsnInputMappingProxy.value !== '' && tsnInputMappingProxy.value !== '',
);

const psProxy = computed(() => kwToHp(information.value?.leistung ?? 0));
</script>
